export default "__VITE_ASSET__bvZP1apk__"